<div *ngIf="userService.hasStudentExperience()">
    <div id="studentNavWrapper" class="student-nav-wrapper">
        <nav class="student-nav" id="site-browse">
            <h1
                *ngIf="userService.isLoggedIn()"
                class="heading mobile-heading selenium-mystuff-label"
            >
                My Stuff
            </h1>
            <h1
                *ngIf="!userService.isLoggedIn()"
                class="heading mobile-heading selenium-mystuff-label"
            >
                Inside
            </h1>
            <div class="left">
                <div
                    class="nav-btn-cntr selenium-assignments"
                    [ngbTooltip]="
                        userService.isLoggedIn()
                            ? ''
                            : 'Log In to start or resume an assignment. Enter an Assignment Code, search or browse the site without logging in.'
                    "
                    placement="bottom"
                    triggers="hover click"
                >
                    <a
                        (click)="toggleTray($event, 'assignments')"
                        [ngClass]="{
                            'nav-tray-open': activeTab == 'assignments'
                        }"
                        href="#"
                        class="assignments-nav-btn student-nav-btn login-required"
                        id="assignments-tab-button"
                        data-code="1"
                        data-no-register="1"
                    >
                        <span class="nav-btn-label" id="assignmentsTab">Assignments</span>
                    </a>
                    <div
                        *ngIf="notStartedCount"
                        [ngClass]="{ large: notStartedCount > 99 }"
                        class="notification-badge"
                    >
                        <span>{{ notStartedCount }}</span>
                    </div>
                </div>

                <div
                    class="nav-btn-cntr selenium-classes"
                    [ngbTooltip]="
                        userService.isLoggedIn()
                            ? ''
                            : 'Log In to view your classes. Enter a roster code to join a class.'
                    "
                    placement="bottom"
                    triggers="hover click"
                >
                    <a
                        [ngClass]="{ 'nav-tray-open': activeTab == 'classes' }"
                        (click)="toggleTray($event, 'classes')"
                        href="#"
                        class="classes-nav-btn student-nav-btn login-required"
                        id="classes-tab-button"
                        data-code="1"
                        data-no-register="1"
                    >
                        <span class="nav-btn-label" id="classesTab">Classes</span>
                    </a>
                </div>

                <div
                    class="nav-btn-cntr selenium-favorites"
                    [ngbTooltip]="userService.isLoggedIn() ? '' : loginFavoriteText"
                    placement="bottom"
                    triggers="hover click"
                >
                    <a
                        href="/student/favorites/"
                        class="favorites-nav-btn student-nav-btn login-required"
                        target="_self"
                        (click)="onFavoriteClick($event)"
                    >
                        <span class="nav-btn-label" id="classesTab">Favorites</span>
                    </a>
                </div>

                <div
                    *ngIf="!userService.isYoungStudent()"
                    class="nav-btn-cntr selenium-projects"
                    [ngbTooltip]="
                        userService.isLoggedIn()
                            ? ''
                            : 'Log In to start or resume a project. Enter an Assignment Code, search or browse the site without logging in.'
                    "
                    placement="bottom"
                    triggers="hover click"
                >
                    <a
                        (click)="toggleTray($event, 'projects')"
                        [ngClass]="{ 'nav-tray-open': activeTab == 'projects' }"
                        href="#"
                        class="creations-nav-btn student-nav-btn login-required"
                        id="projects-tab-button"
                        data-code="1"
                        data-no-register="1"
                    >
                        <span class="nav-btn-label" id="projectsTab">Projects</span>
                    </a>
                </div>
            </div>
            <div *ngIf="activeTab === 'none'" class="right">
                <div class="enter-code">
                    <div class="question">Have a class or assignment code?</div>
                    <div class="guidance-mobile">Enter class or assignment code here.</div>
                    <div class="code-wrapper">
                        <div class="enter-it-here">Enter it here:</div>
                        <div class="code-input">
                            <form (submit)="enterGenericCode($event)" class="nav-search-form">
                                <input
                                    class="student-action-input selenium-enter-a-code search-input"
                                    type="search"
                                    id="enter-a-code"
                                    [(ngModel)]="enterCode"
                                    name="enterCode"
                                    placeholder="e.g., 12345banana"
                                />
                                <button
                                    type="submit"
                                    class="enter-code-go"
                                    (click)="enterGenericCode($event)"
                                >
                                    Go
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    </div>
    <div class="trays-container">
        <div class="student-tray" [ngClass]="{ closed: activeTab === 'none' }">
            <div (click)="closeTray()" id="tray-close" class="tray-container">
                <span
                    class="close-tab-list"
                    data-target="#students-tray"
                    (click)="toggleTray($event, '')"
                    ><i class="lm lm-cross"></i
                ></span>
            </div>
            <div class="tray-container">
                <section *ngIf="activeTab === 'assignments'" class="main-panel panel-body">
                    <app-student-assignments></app-student-assignments>
                </section>
                <section *ngIf="activeTab === 'projects'" class="main-panel panel-body">
                    <app-student-projects></app-student-projects>
                </section>
                <section *ngIf="activeTab === 'classes'" class="main-panel panel-body">
                    <app-student-classes
                        (joinCodeEntered)="joinClass($event)"
                    ></app-student-classes>
                </section>
            </div>
        </div>
    </div>
</div>
